const columnSet = [
  { label: '事業所名', key: 'company_name', modal: true, default: true, sort: true },
  { label: '募集職種', key: 'jobtype_name', modal: true, default: true },
  { label: 'メディア', key: 'media_name', spLabel: true, default: true, sort: true },
  { label: '広告プラン', key: 'article_plan_name', spLabel: true, default: true, sort: true },
  { label: '掲載開始日', key: 'acquisition_date', spLabel: true, default: true, sort: true },
  { label: '掲載状況', key: 'posting_situation', posting: true, default: true },
  { label: '事業所ID', key: 'company_id', sort: true },
  { label: '広告金額', key: 'article_plan', articlePlan: true, sort: true },
  { label: '所在地/都道府県', key: 'prefecture', sort: true },
  { label: '所在地/市区町村', key: 'city', sort: true },
  { label: '企業HP', key: 'company_url', url: true },
  { label: '電話番号', key: 'campany_tel' },
  { label: '求人ID', key: 'id' },
  // 給与は種別（時給/日給/月給/年収）ごとに単位が違うため、種別が選ばれていないとソートできない
  { label: '給与', key: 'salary', sort: true, sortRequires: 'salaryCd' },
  { label: '掲載終了日', key: 'view_end_date', multiple: true },
  { label: '雇用形態', key: 'employment_name', multiple: true },
  { label: '採用担当者', key: 'recruiting_personnel' },
]
const defaultKeys = columnSet.concat().filter(key => key.default).map(({ key }) => key)

export default {
  namespaced: true,

  state: {
    sorting: false,
    columns: [],
    displayedColumns: [],
  },
  mutations: {
    configure: (state, { columns, displayedColumns }) => {
      state.columns = columns
      state.displayedColumns = displayedColumns
    },
    clear: (state) => {
      state.sorting = false
      state.columns = []
      state.displayedColumns = []
    },
    sort: (state) => {
      state.sorting = !state.sorting
    },
    done: (state) => {
      state.sorting = false
    },
  },
  actions: {
    initialize ({ commit }, { displayedColumns, spMode }) {
      // 表示項目変更・並び替え は SP ではデザインの都合で無効
      if (displayedColumns && !spMode) {
        const filteredColumns = displayedColumns.filter(d => columnSet.find(c => c.key === d))
        const prioritizeColumns = filteredColumns.map(d => columnSet.find(c => c.key === d))
        const otherColumns = columnSet.filter(c => filteredColumns.indexOf(c.key) < 0)
        const columns = prioritizeColumns.concat(otherColumns)
        commit('configure', { columns, displayedColumns: filteredColumns })
      } else {
        commit('configure', { columns: columnSet.concat(), displayedColumns: defaultKeys })
      }
    },
    async configure ({ commit, dispatch }, { columns, displayedColumns }) {
      commit('configure', { columns, displayedColumns })
      await dispatch('persist', { displayedColumns })
    },
    async persist ({ dispatch }, { displayedColumns }) {
      const filteredColumns = displayedColumns.filter(d => columnSet.find(c => c.key === d))
      try {
        await dispatch('user/updateJobDisplayedColumns', { displayedColumns: filteredColumns }, { root: true })
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/job-table-configuration.js